import React, { Fragment, useEffect } from "react";
import { CookieConsentBanner } from "@ADC/components/Views";

const Layout = ({ children, className = "" }) => {
  useEffect(() => {
    window._mfq = window._mfq || [];
    (function () {
      var mf = document.createElement("script");
      mf.type = "text/javascript";
      mf.defer = true;
      mf.src =
        "//cdn.mouseflow.com/projects/0eaa3584-3d5e-4d69-8ad8-ee3c250d2668.js";
      document.getElementsByTagName("head")[0].appendChild(mf);
    })();
  }, []);

  return (
    <Fragment>
      <CookieConsentBanner />
      <main className={`${className} relative`}>{children}</main>

      <script
        dangerouslySetInnerHTML={{
          __html: `
    (function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"97097968", enableAutoSpaTracking: true};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");
    `,
        }}
      />
    </Fragment>
  );
};

export default Layout;
